import { Link } from "react-router-dom";
import { styleForCategory } from "../lib/visual";
import type { Performer } from "../types/api";
import styles from "./PerformerChip.module.css";

export default function PerformerChip({ performer }: { performer: Performer }) {
  const style = styleForCategory(performer.categoryId);
  const initials = performer.name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase())
    .join("");

  return (
    <Link
      to={`/search?q=${encodeURIComponent(performer.name)}`}
      className={styles.chip}
    >
      <span className={styles.avatar} style={{ background: style.gradient }}>
        {initials}
      </span>
      <span className={styles.body}>
        <span className={styles.name}>{performer.name}</span>
        {performer.description && (
          <span className={styles.desc}>{performer.description}</span>
        )}
      </span>
    </Link>
  );
}
